const action_types = {
  FETCH_USER: "FETCH_USER",
  FETCH_FILE: "FETCH_FILE",
  FETCH_VIDEO: "FETCH_VIDEO",
  CLEAR_VIDEO: "CLEAR_VIDEO"
}

export default action_types